import { useState, useEffect } from 'react';
import { DialogTrigger, Dialog, Modal } from 'react-aria-components';
import { useForm, SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';

import { useAtom } from 'jotai';

import { getGuardians } from '@/api/getGuardians';
import { LineUserRequest, updateLineUser } from '@/api/updateLineUser';
import Button from '@/components/Button/Button';
import InputText from '@/components/InputText/InputText';
import SelectField from '@/components/SelectField/SelectField';
import { UserAtom } from '@/jotai/jotai';
import { Guardian } from '@/types/guardian';
import { LineAccountUser } from '@/types/user';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  afterSubmit: () => void;
  lineUser?: LineAccountUser;
};

export const EditLineUserDialog = ({ isOpen, setIsOpen, afterSubmit, lineUser }: Props) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<LineUserRequest>({
    defaultValues: {
      staff_id: lineUser ? lineUser.staff_id : 0,
      guardian_id: lineUser ? lineUser.guardian_id : 0,
    },
  });

  const [guardians, setGuardians] = useState<Guardian[]>([]);

  const [loginUser] = useAtom(UserAtom);

  useEffect(() => {
    const fetchGuardians = async () => {
      const result = await getGuardians(loginUser?.email);
      if (result.status === 200) {
        setGuardians(result.result);
        console.log(result.result);
      }
    };
    fetchGuardians();
  }, [loginUser?.email]);

  const onSubmit: SubmitHandler<LineUserRequest> = async (data) => {
    console.log(data);
    console.log(lineUser);
    try {
      const result = await updateLineUser({
        line_id: lineUser?.line_id || '',
        staff_id: Number(data.staff_id) || undefined,
        guardian_id: Number(data.guardian_id) || undefined,
      });
      if (result.status === 200) {
        toast.success('更新しました');
      } else {
        toast.error('更新に失敗しました');
      }
    } catch (error) {
      toast.error('更新に失敗しました');
    }

    setIsOpen(false);
    afterSubmit();
  };

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(false)}
    >
      <Modal className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <Dialog className="w-[600px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-4">
              <span className="text-sm text-gray-400">
                ※スタッフに切り替える時は7を入力してください
              </span>
              <InputText
                label="スタッフID"
                type="text"
                required={true}
                {...register('staff_id')}
              />
            </div>
            <div className="flex flex-row gap-4">
              <SelectField
                name="guardian_id"
                label="保護者"
                control={control}
                items={guardians
                  .map((guardian) => ({
                    label: guardian.last_name + guardian.first_name,
                    value: guardian.id.toString(),
                  }))
                  .concat([{ label: '未設定', value: '0' }])}
                required={true}
              />
            </div>
            <div className="mt-10 flex flex-row items-center justify-center space-x-2">
              <Button
                type="submit"
                size="lg"
                variant="outline"
                onClick={() => setIsOpen(false)}
              >
                戻る
              </Button>
              <Button
                type="submit"
                size="lg"
                variant={Object.keys(errors).length > 0 ? 'disabled' : 'solid-fill'}
                disabled={Object.keys(errors).length > 0}
              >
                保存
              </Button>
            </div>
          </form>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
